/** @format */

import { Component, Input } from '@angular/core';
@Component({
	selector: 'home-priced-package',
	templateUrl: './priced-package.component.html',
	styleUrl: './priced-package.component.scss',
	standalone: false
})
export class PricedPackageComponent {
	@Input() addlData: any;
	@Input() data: any;
	@Input() packagePrice: string;
	@Input() purchasedSeperately: string;
}
